import { ChangeDetectionStrategy, Component } from '@angular/core'

import { CmpRichText } from 'app/core/cms/generated/api-types'
import { LexicalRichTextDirective } from 'app/shared/richtext/lexical-rich-text.directive'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-cmp-rich-text',
  template: ` <div [paiLexicalRichText]="data().richText"></div> `,
  styleUrls: ['./cmp-rich-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LexicalRichTextDirective],
  providers: [{ provide: CmsBlock, useExisting: CmpRichTextComponent }],
})
export class CmpRichTextComponent extends CmsBlock<CmpRichText> {
  readonly __typename = 'CmpRichText'
}
